import { Record, List } from 'immutable';
import CurrencyUtilities from 'records/CurrencyUtilities';

const defaultValues = {
  id: null,
  recipeId: null,
  ingredientName: '',
  note: '',
  ingredientBrand: '',
  supc: '',
  source: 0,
  amountUsedInRecipe: 0,
  amount: 0, // only user for endeca search
  initialAmountUsedInRecipe: null, // for endeca create only.
  amountUnitTextKey: '',
  baseUnitTextKey: '',
  costPerUnit: 0,
  costPerServing: 0,
  totalCost: 0,
  isSoldByWeight: true,
  archived: false,
  createdBy: 0,
  created: null,
  updatedBy: 0,
  updated: null,
  ordinal: 0,
  isSyscoBrand: false,
  lastOrderedDate: null,
  packSizePack: 0,
  packSizeSize: '',
  averageWtPerCase: 0.0,
  yield: null,
  noOfEaches: 0.0,
  isCatchWeight: false,
  costPerUnitDerived: null,
  batchRecipeId: '-1',
  timesUsed: null,
  isSoldAs_split: false,
  isSoldAs_case: false,
  usedInRecipes: new List(),
  customUomId: null,
  customUom: null,
  needUpdate: false,
  mainCategoryId: null,
  mainCategoryName: null,
  stockDesc: null,
  stockFlag: null,
  isSupcValid: true,
  error: null,
  searchString: null,
  foundFrom: null,
  errorType: null,
  isUserIngredient: false
};

export default class Ingredient extends Record(defaultValues, Ingredient) {
  constructor(values) {
    super({
      ...values,
      costPerUnit: values && values.costPerUnit
                    ? CurrencyUtilities.currencyFormatIngredient(values.costPerUnit)
                    : defaultValues.costPerUnit,
      costPerServing: values && values.costPerServing
                    ? CurrencyUtilities.currencyFormatIngredient(values.costPerServing)
                    : defaultValues.costPerServing,
      totalCost: values && values.totalCost
                    ? CurrencyUtilities.currencyFormatIngredient(values.totalCost)
                    : defaultValues.totalCost,
    });
  }

  static getIngredientById(ingredients, id) {
    return ingredients.find((item) => {
      return item.get('id') === id ? item : undefined;
    });
  }

  static getActiveIngredients(ingredients) {
    return ingredients.filter((item) => {
      return item.get('archived') === false;
    });
  }

  static getIngredientIndexById(ingredients, id) {
    return ingredients.findIndex(item => {
      return item.get('id') === id ? item : undefined;
    });
  }

  static deleteIngredientByIndex(ingredients, index) {
    return ingredients.delete(index);
  }

  static insertIngredientByIndex(ingredients, index, ingredient) {
    return ingredients.insert(index, ingredient);
  }

  static sortIngredientsByOrdinal(ingredients) {
    return ingredients.sort((itemOne, itemTwo) => {
      if (itemOne.get('ordinal') < itemTwo.get('ordinal')) return -1;
      if (itemOne.get('ordinal') > itemTwo.get('ordinal')) return 1;
      return 0;
    });
  }

  static updateIngredientOrdinalsFromIndex(ingredients) {
    return ingredients.map((item, index) => {
      return item.set('ordinal', index);
    });
  }

  static getNextOrdinal(ingredients) {
    const items = this.sortIngredientsByOrdinal(ingredients);
    const item = items.last();
    if (item) {
      return item.get('ordinal') + 1;
    }
    return 0;
  }

  static formatIngredientsForOrdinalUpdate(ingredients) {
    const ingredientsData = {
      ids: [],
    };
    ingredients.forEach((item) => {
      ingredientsData.ids.push(item.get('id'));
    });
    return ingredientsData;
  }

  static getSubBatchRecipes(ingredients) {
    return ingredients.filter((item) => {
      return item.get('batchRecipeId') > 0;
    });
  }

  static getProductRecipes(ingredients) {
    return ingredients.filter((item) => {
      return item.get('supc').length > 0;
    });
  }

  static getNeedUpdateCustomIngredient(ingredients) {
    return ingredients.filter((item) => {
      return item.get('needUpdate') === true;
    })
  }

  static filterIngredientsByIngredientName(ingredients, keywords) {
    let keywordsUpper = keywords ? keywords.toUpperCase() : null;
    return ingredients.filter((ingredient) => {
      return ingredient.get('ingredientName') && ingredient.get('ingredientName').toUpperCase().includes(keywordsUpper);
    });
  }

  static filterIngredientById(ingredients, id) {
    return ingredients.filter((item) => {
      return item.get('id') === id;
    });
  }

  static searchIngredientsByIngredientName(ingredients, keywords) {
    return ingredients.filter((ingredient) => {
      return ingredient.get('ingredientName') && ingredient.get('ingredientName') === keywords;
    });
  }

  static validator(type, value) {
    if(type === 'number') {
      return value >= 0;
    }
    if(type === 'string') {
      return value.trim().length > 0;
    }
  }
}

export const Ingredients = (data) => {
  let ingredients = new List();
  if (data) {
    data.forEach((value) => {
      ingredients = ingredients.push((value instanceof Ingredient)? value: (new Ingredient(value)) );
    });
  }
  return ingredients;
};
